export default "__VITE_ASSET___mFMk5VG__"